export enum LoginDestination {
  Portal = 0,
  App = 1,
  Admin = 2
}
